import React, { useCallback } from 'react'
import BoxContainer from './BoxContainer';
import { FixedSizeList as List } from "react-window";
import FavParameterRow from './FavParameterRow';
import { Typography } from '@mui/material';

const FavParamInformation = ({favData,handleRemoveFavParam,onChange, onFocus, onBlur}) => {
    const itemData = React.useMemo(() => ({
        favData: favData,
        onChange,
        onFocus,
        onBlur,
    }), [favData, onChange, onFocus, onBlur]);

    const Row = useCallback(({ index, style, data }) => {
        const param = data.favData[index];
        return (
          <div style={style} key={param.id}>
            <FavParameterRow
              param={param}
              onChange={(value) => data.onChange(param, value)}
              onFocus={data.onFocus}
              onBlur={data.onBlur}
              handleRemoveFavParam={handleRemoveFavParam}
            />
          </div>
        );
    }, []);

    return (
        <>
            <BoxContainer maxHeight={'270px'} >
                {favData.length > 0 ?
                    <List
                        height={287}
                        itemCount={favData.length}
                        itemSize={35}
                        //width="100%"
                        itemData={itemData}
                        className='paramContainerScroll'
                    >
                        {Row}
                    </List>
                :
                <Typography sx={{ fontSize: '0.75rem',fontWeight:'500' }} component="span">No Data Available. </Typography>  
            
            }
            </BoxContainer>
       
        </>
    )
}

export default FavParamInformation